import { all, getContext, put } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';
import { Action } from 'redux-actions';
import { Config } from '../../../../context';

import { CheckoutOrderFragment } from '@websky/graphql';

import { setPassengers } from './passengers/actions';
import { documentsSagas } from './documents/sagas';
import { getInitialPassengersState } from '../lib/getInitialPassengersState';
import { RefundPassengersState } from './types';
import { shouldSkipPassengers } from '@shared/lib/passengers';

export function* createInitialRefundState({ payload }: Action<CheckoutOrderFragment>) {
	const {
		global: {
			companyInfo: { iataCode }
		}
	}: Config = yield getContext('config');

	const initialValue = shouldSkipPassengers(payload.travellers?.length ?? 0, iataCode);

	const actions: Action<RefundPassengersState>[] = [
		setPassengers(getInitialPassengersState(payload.travellers, initialValue))
	];

	yield put(batchActions(actions));
}

export function* refundSagas() {
	yield all([documentsSagas()]);
}
